import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Youtube({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 17 13"
    >
      <Path
        d="M15.8539 3.31943C15.655 2.02673 15.0583 1.13179 13.6662 0.93291C11.4786 0.535156 8.09766 0.535156 8.09766 0.535156C8.09766 0.535156 4.71675 0.535156 2.5291 0.93291C1.13696 1.13179 0.440894 2.02673 0.341455 3.31943C0.142578 4.61213 0.142578 6.50146 0.142578 6.50146C0.142578 6.50146 0.142578 8.3908 0.341455 9.6835C0.540332 10.9762 1.13696 11.8711 2.5291 12.07C4.71675 12.4678 8.09766 12.4678 8.09766 12.4678C8.09766 12.4678 11.4786 12.4678 13.6662 12.07C15.0583 11.7717 15.655 10.9762 15.8539 9.6835C16.0527 8.3908 16.0527 6.50146 16.0527 6.50146C16.0527 6.50146 16.0527 4.61213 15.8539 3.31943ZM6.10889 9.48462V3.51831L11.0808 6.50146L6.10889 9.48462Z"
        fill={iconColor}
      />
    </Svg>
  );
}
